module.exports = __webpack_public_path__ + "./JimmyPhoto_02873ce17d5bd90f88cb4b735f466d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/JimmyPhoto.png
// module id = 531
// module chunks = 0